Ext.define('SA.EditView', {
    alias: 'widget.edit-view',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-view',

    initComponent() {
        this.items = [
            {
                xtype: 'edit-header',
                enableDoneButton: this.enableDoneButton
            }, {
                xtype: 'simple-container',
                cls: 'sa-edit-view-sections-wrap',
                itemId: 'sectionsWrap',

                items: [
                    {
                        xtype: 'simple-container',
                        cls: 'sa-edit-view-sections',
                        items: this.panels
                    }
                ]
            }
        ];

        this.callParent();

        this.header = this.down('edit-header');
        this.sectionsWrap = this.down('#sectionsWrap');

        this.header.on('done:click', () => this.fireEvent('done:click'));
    },

    onDoneClick(callback, scope) {
        this.on('done:click', callback, scope);
    },

    scrollToEl(getEl) {
        if (!getEl()) {
            setTimeout(() => this.scrollToEl(getEl));
            return;
        }

        getEl().scrollIntoView({block: 'nearest'});
    },

    setHeaderVisible(visible) {
        this.header.setVisible(visible);
    },

    setSectionsVisible(visible) {
        this.sectionsWrap.setVisible(visible);
    },

    setViewName(viewName) {
        this.header.setTitleHtml(`Edit ${Ext.String.htmlEncode(viewName)}`);
    },

    setWarningMessage(message) {
        this.header.setWarningMessage(message);
    }
});